import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../../../filters';

export default {
  name: 'refundDeposit',
  components: {

  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      appData: {
        deposits: [],
        text: '',
        allowToChangeAmount: false,
        totalAmount: 0
      },
      lang: '',
      readOnly: false,
      options: { pageSize: 10, total: 0, page: 1 },
      totalRow: 0,
      gridCols: [],
      noDataFound: false,
      keyColumn: 'readingNumber',
      rowIdx: -1
    }
  },
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('refund_deposit_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
        this.appData = this.dataObj.appData;
        console.log(this.appData);
        this.readOnly = this.dataObj.readOnly;
      });
    },
    setData(info) {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        text: '',
        allowToChangeAmount: false,
        totalAmount: 0
      };

      this.$store.state.notifier.asyncBlock(
        axios.post('/RefundDepositActivity/SetData', parameter),
        response => {
          if (response.status == 200) {
            this.$alertMsg(this.$t('messages.refundDepositSuccess'),2 );
          }
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text)
      );

      //let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      //axios.post('/RefundDepositActivity/SetData', parameter)
      //  .then(response => {
      //    if (response.status == 200) {
      //      this.$alertMsg(this.$t('messages.refundDepositSuccess'), 0);
      //    }
      //    else {
      //      this.$alertMsg(response.data.data.text, 1);
      //    }
      //    loader.hide();
      //  })
      //  .catch(error => {
      //    loader.hide();
      //   this.$alertMsg(error.response.data);
      //  });
    },
    getData() {
      var parameter = {
        ApplicationId: this.app.id,
        ApplicationKey: 0
      };

      this.$store.state.notifier.asyncBlock(
        axios.post('/RefundDepositActivity/GetData', parameter),
        response => {
          if (response.status == 200) {
            this.services = response.data.item;
          }
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text)
      );

      //axios.post('/RefundDepositActivity/GetData', parameter)
      //  .then(response => {
      //    if (response.status == 200) {
      //      this.services = response.data.item;
      //    }
      //  })
      //  .catch(error => {
      //   this.$alertMsg(error.response.data);
      //  });
    },
    refAmountChange(index) {
      if (Number(this.appData.deposits[index].refAmount) > this.appData.deposits[index].maxRefAmount)
        this.appData.deposits[index].refAmount = this.appData.deposits[index].maxRefAmount;
      else
        this.appData.deposits[index].refAmount = Number(this.appData.deposits[index].refAmount);

      this.calcTotalAmount();
    },
    calcTotalAmount() {
      var tot = 0;

      for (var i = 0; i < this.appData.deposits.length; i++) {
        if (this.appData.deposits[i].selected) {
          tot += Number(this.appData.deposits[i].refAmount);
        }
      }

      this.appData.totalAmount = tot;
    }
  },
}
